import {defineStore} from 'pinia'


// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application


function makeSeparatedStore(defineStore) {
    const definedStores = new Map();

    return function(storeKey) {
        if (!definedStores.has(storeKey)) {
            definedStores.set(storeKey, defineStore(storeKey));
        }

        // @ts-expect-error
        return definedStores.get(storeKey)();
    };
}

export const createTestStore = makeSeparatedStore((key = 'default') =>
    defineStore(`test/${key}`,{
        state: () => {
            return {
                state: 'initializing',
                data: 'default'
            }
        },

        getters: {},
        actions: {


            changeData(value) {

                let self = this;
                self.data = value;

            }


        }
    }),
);
